import { render, staticRenderFns } from "./VuexPage.vue?vue&type=template&id=cfd05e8e&"
import script from "./VuexPage.vue?vue&type=script&lang=js&"
export * from "./VuexPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd05e8e')) {
      api.createRecord('cfd05e8e', component.options)
    } else {
      api.reload('cfd05e8e', component.options)
    }
    module.hot.accept("./VuexPage.vue?vue&type=template&id=cfd05e8e&", function () {
      api.rerender('cfd05e8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/VuexPage.vue"
export default component.exports